<template>
  <MainHeader />
  <MainSidebar />
  <div class="main-content bg_gray d-flex flex-column transition overflow-hidden">
    <BreadcrumbMenu pageTitle="Recepción de Mercadería" />

    <div class="flex-grow-1 overflow-auto px-3 pb-3">
      <template v-if="!compraSeleccionada">
        <div class="card mb-3">
          <div class="card-body py-3">
            <h6 class="card-title mb-1">Compras pendientes de recepción</h6>
            <p class="text-muted small mb-0">Estas compras fueron importadas desde XML pero el stock aún no se ha actualizado.</p>
          </div>
        </div>

        <div v-if="cargandoLista" class="text-center py-5">
          <div class="spinner-border text-primary"></div>
        </div>
        <div v-else-if="!compras.length" class="alert alert-info">
          No hay compras pendientes de recepción.
        </div>
        <div v-else class="card">
          <div class="card-body p-0">
            <table class="table table-hover mb-0">
              <thead class="table-light">
                <tr>
                  <th>Factura</th>
                  <th>Proveedor</th>
                  <th>Fecha factura</th>
                  <th>Fecha importación</th>
                  <th class="text-end">Total (S/)</th>
                  <th class="text-center">Items</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="c in compras" :key="c.idreg">
                  <td><code>{{ c.serie }}-{{ c.numero }}</code></td>
                  <td class="small">{{ c.proveedor }}</td>
                  <td class="small">{{ formatFecha(c.fecha_emision) }}</td>
                  <td class="small">{{ formatFecha(c.fecha_recep) }}</td>
                  <td class="text-end small">{{ fmtMonto(c.montototdoc) }}</td>
                  <td class="text-center">
                    <span class="badge bg-warning-subtle text-warning">{{ c.total_items }}</span>
                  </td>
                  <td class="d-flex gap-2 justify-content-end">
                    <button class="btn btn-sm btn-outline-secondary" @click="verDetalle(c)" title="Ver detalle">
                      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/><path stroke-linecap="round" stroke-linejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/></svg>
                    </button>
                    <button class="btn btn-sm btn-primary" @click="seleccionar(c)">Recibir</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
      <template v-else>

        <!-- Cabecera -->
        <div class="card mb-3">
          <div class="card-body py-3 d-flex justify-content-between align-items-start">
            <div>
              <h6 class="mb-1">
                {{ compraSeleccionada?.serie }}-{{ compraSeleccionada?.numero }}
                <span class="text-muted fw-normal small ms-2">{{ compraSeleccionada?.proveedor }}</span>
                <span class="badge ms-2" style="font-size:10px;background:linear-gradient(135deg,#6366f1,#4f46e5);color:#fff">BETA</span>
              </h6>
              <div class="small text-muted">
                Fecha factura: {{ formatFecha(compraSeleccionada?.fecha_emision) }} &nbsp;·&nbsp;
                Total: S/ {{ fmtMonto(compraSeleccionada?.montototdoc) }}
              </div>
              <div class="d-flex align-items-center gap-2 mt-2">
                <div class="progress" style="width:160px;height:6px">
                  <div class="progress-bar bg-success" :style="`width:${progresoPorc}%`"></div>
                </div>
                <span class="small text-muted">{{ productosCompletos }} de {{ totalProductos }} modelos listos</span>
              </div>
            </div>
            <button class="btn btn-sm btn-outline-secondary" @click="volver">← Volver</button>
          </div>
        </div>

        <!-- Buscador -->
        <div class="d-flex align-items-center gap-2 mb-3">
          <input v-model="busqueda" type="text" class="form-control form-control-sm"
            style="max-width:320px" placeholder="Buscar modelo: HQ2426, LIGHTSHIFT…" />
          <span v-if="busqueda" class="small text-muted">{{ productosAgrupados.length }} resultados</span>
        </div>

        <!-- Cards por producto -->
        <div v-if="productosAgrupados.length === 0" class="alert alert-warning">
          No se encontraron productos con "{{ busqueda }}"
        </div>

        <div v-for="grupo in productosAgrupados" :key="grupo.codigo_proveedor"
          class="card mb-2 overflow-hidden"
          :class="grupoCompleto(grupo) ? 'border-success' : ''">

          <div class="d-flex justify-content-between align-items-center px-3 py-2 flex-wrap gap-2"
            :style="grupoCompleto(grupo) ? 'background:#f0fdf4' : 'background:#f8f9fa'">
            <div class="d-flex align-items-center gap-2">
              <code class="fw-bold" style="font-size:13px">{{ grupo.codigo_proveedor }}</code>
              <span class="small text-muted text-truncate" style="max-width:280px">{{ grupo.producto }}</span>
            </div>
            <div class="d-flex align-items-center gap-2 flex-wrap">
              <!-- Género y Línea -->
              <template v-if="grupo.tallas[0]?.idtalla === -1">
                <!-- Sin género — mostrar selectores para asignar -->
                <select v-model="grupo.idtalla_sel" class="form-select form-select-sm"
                  style="width:150px;font-size:12px"
                  :class="!grupo.idtalla_guardado ? 'border-warning' : 'border-success'"
                  @change="guardarGeneroLinea(grupo)">
                  <option :value="undefined" disabled>Género…</option>
                  <option v-for="t in catalogoTallas" :key="t.idtalla" :value="t.idtalla">{{ t.nombre }}</option>
                </select>
                <select v-model="grupo.idlinea_sel" class="form-select form-select-sm"
                  style="width:150px;font-size:12px"
                  :class="!grupo.idtalla_guardado ? 'border-warning' : 'border-success'"
                  @change="guardarGeneroLinea(grupo)">
                  <option :value="undefined" disabled>Línea…</option>
                  <option v-for="l in catalogoLineas" :key="l.idlinea" :value="l.idlinea">{{ l.nombre }}</option>
                </select>
              </template>
              <template v-else>
                <!-- Ya tiene género — mostrar como texto -->
                <span class="badge bg-light text-dark border" style="font-size:11px">{{ grupo.nombreTalla }}</span>
                <span class="badge bg-light text-dark border" style="font-size:11px">{{ grupo.nombreLinea }}</span>
              </template>
              <!-- Precio de venta -->
              <template v-if="!grupo.precvta_guardado">
                <div class="d-flex align-items-center gap-1">
                  <span class="small text-muted">S/</span>
                  <input v-model.number="grupo.precvta_input" type="number" min="0.01" step="0.01"
                    placeholder="P. venta"
                    class="form-control form-control-sm border-warning"
                    style="width:90px;font-size:12px"
                    @blur="guardarPrecioVenta(grupo)"
                    @keyup.enter="guardarPrecioVenta(grupo)" />
                </div>
              </template>
              <template v-else>
                <span class="badge bg-light text-dark border" style="font-size:11px">S/ {{ grupo.precvta_input }}</span>
              </template>

              <span class="small text-muted">{{ totalUnidadesGrupo(grupo) }} u. factura</span>
              <span v-if="grupoCompleto(grupo)" class="badge bg-success">✓ Listo</span>
              <span v-else-if="grupoParciallisto(grupo)" class="badge bg-warning text-dark">
                {{ tallasListasGrupo(grupo) }}/{{ grupo.tallas.length }} tallas
              </span>
              <span v-else class="badge bg-secondary">Pendiente</span>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table table-sm mb-0" style="font-size:13px">
              <thead style="background:#f0f0f0">
                <tr>
                  <th class="text-center ps-3" style="width:70px">Talla</th>
                  <th class="text-center" style="width:80px">Factura</th>
                  <th class="text-center" style="width:110px">Recibido</th>
                  <th>Código de barras</th>
                  <th class="text-center pe-3" style="width:90px">Estado</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in grupo.tallas" :key="item.iddet" :class="rowItemClass(item)">
                  <td class="text-center ps-3">
                    <span class="badge bg-light text-dark border fw-semibold" style="font-size:12px">
                      {{ item.talla_usa || '—' }}
                    </span>
                  </td>
                  <td class="text-center text-muted">{{ parseInt(item.cantidad) }}</td>
                  <td class="text-center">
                    <template v-if="item.stock_actualizado">
                      <span class="small text-muted">{{ item.cantidadRecibida }}</span>
                    </template>
                    <template v-else>
                      <div class="d-flex align-items-center justify-content-center gap-1">
                        <input v-model.number="item.cantidadRecibida" type="number" min="0"
                          class="form-control form-control-sm text-center p-0"
                          style="width:58px;font-size:12px"
                          :class="item.cantidadRecibida == 0 ? 'border-secondary' : item.cantidadRecibida != parseInt(item.cantidad) ? 'border-warning' : ''"
                          @input="onCantidadChange(item)" />
                        <span v-if="item.guardandoCantidad" title="Guardando..." style="font-size:10px;color:#6c757d">↑</span>
                      </div>
                    </template>
                  </td>
                  <td>
                    <template v-if="item.stock_actualizado">
                      <code class="small text-muted">{{ item.barcodeTemporal || item.codbarras }}</code>
                    </template>
                    <template v-else-if="item.cantidadRecibida == 0">
                      <span class="small text-muted fst-italic">No recibido</span>
                    </template>
                    <template v-else-if="item.codbarras && !item.barcodeTemporal">
                      <code class="small text-success">{{ item.codbarras }}</code>
                    </template>
                    <template v-else>
                      <div class="d-flex align-items-center gap-1">
                        <input v-model="item.barcodeTemporal" type="text"
                          class="form-control form-control-sm"
                          style="max-width:210px;font-size:12px"
                          :class="item.barcodeTemporal ? 'border-success' : 'border-danger'"
                          placeholder="Escanea o escribe el código"
                          @change="guardarBarcodeItem(item)" />
                        <span v-if="item.guardandoBarcode" title="Guardando..." style="font-size:10px;color:#6c757d">↑</span>
                      </div>
                    </template>
                  </td>
                  <td class="text-center pe-3">
                    <span v-if="item.stock_actualizado" class="badge bg-success">✓ En stock</span>
                    <span v-else-if="item.cantidadRecibida == 0" class="badge bg-secondary">0 u.</span>
                    <span v-else-if="item.codbarras || item.barcodeTemporal" class="badge bg-success">✓</span>
                    <span v-else class="badge bg-danger">Falta CB</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div v-if="errorConfirmar" class="alert alert-danger mt-3">{{ errorConfirmar }}</div>

        <!-- Barra inferior fija -->
        <div style="position:sticky;bottom:0;z-index:10;background:#fff;border-top:1px solid #dee2e6;margin:0 -12px;padding:12px 16px" class="d-flex align-items-center justify-content-between gap-3 flex-wrap">
          <div class="small text-muted d-flex gap-3">
            <span v-if="itemsConfirmados > 0" class="text-success fw-semibold">✓ {{ itemsConfirmados }} en stock</span>
            <span v-if="itemsPendientes > 0" class="text-primary">{{ itemsPendientes }} listos para confirmar</span>
            <span v-if="itemsSinBarcode > 0" class="text-danger">{{ itemsSinBarcode }} sin barcode</span>
            <span v-if="gruposSinPrecio > 0" class="text-danger">{{ gruposSinPrecio }} sin precio de venta</span>
          </div>
          <div class="d-flex gap-2">
            <button class="btn btn-outline-secondary btn-sm" :disabled="cerrando" @click="cerrarRecepcion"
              title="Cierra la recepción aunque queden ítems pendientes — para cuando no llega más mercadería">
              <span v-if="cerrando" class="spinner-border spinner-border-sm me-1"></span>
              {{ cerrando ? 'Cerrando…' : 'Cerrar recepción' }}
            </button>
            <button class="btn btn-success"
              :disabled="confirmando || itemsPendientes === 0 || gruposSinPrecio > 0"
              :title="gruposSinPrecio > 0 ? 'Ingresa el precio de venta en todos los productos antes de confirmar' : ''"
              @click="confirmarParcial">
              <span v-if="confirmando" class="spinner-border spinner-border-sm me-1"></span>
              {{ confirmando ? 'Actualizando…' : `Confirmar lo recibido (${itemsPendientes})` }}
            </button>
          </div>
        </div>
      </template>

    </div>
  </div>

  <!-- ─── Modal: diferencias de cantidad (revisión antes de confirmar) ──── -->
  <div v-if="modalDiscrepancias" class="modal d-block" style="background:rgba(0,0,0,0.55)">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <div>
            <h6 class="modal-title fw-semibold mb-0">Diferencias en cantidades recibidas</h6>
            <p class="small text-muted mb-0 mt-1">Revisa antes de confirmar. Puedes descargar este reporte para enviarlo al proveedor o a contabilidad.</p>
          </div>
        </div>
        <div class="modal-body p-0">
          <table class="table table-sm mb-0">
            <thead class="table-light">
              <tr>
                <th class="ps-3">Código</th>
                <th>Producto</th>
                <th class="text-center">Talla</th>
                <th class="text-center">Factura</th>
                <th class="text-center">Recibido</th>
                <th class="text-center">Diferencia</th>
                <th class="text-center pe-3">Tipo</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="d in modalDiscrepancias" :key="d.iddet"
                :class="d.diferencia < 0 ? 'table-warning' : 'table-info'">
                <td class="ps-3"><code class="small">{{ d.codigo_proveedor }}</code></td>
                <td class="small">{{ d.producto }}</td>
                <td class="text-center"><span class="badge bg-light text-dark border">{{ d.talla_usa || '—' }}</span></td>
                <td class="text-center">{{ d.cantidadFactura }}</td>
                <td class="text-center fw-semibold">{{ d.cantidadRecibida }}</td>
                <td class="text-center fw-bold" :class="d.diferencia < 0 ? 'text-danger' : 'text-primary'">
                  {{ d.diferencia > 0 ? '+' : '' }}{{ d.diferencia }}
                </td>
                <td class="text-center pe-3">
                  <span v-if="d.diferencia < 0" class="badge bg-warning text-dark">Faltante</span>
                  <span v-else class="badge bg-info text-dark">Exceso</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer d-flex justify-content-between align-items-center">
          <div class="small text-muted">
            <span class="text-warning fw-semibold">{{ discrepanciasFaltante }} faltantes</span>
            <template v-if="discrepanciasExceso"> · <span class="text-info fw-semibold">{{ discrepanciasExceso }} excesos</span></template>
          </div>
          <div class="d-flex gap-2">
            <button class="btn btn-sm btn-outline-secondary" @click="modalDiscrepancias = null">Volver y corregir</button>
            <button class="btn btn-sm btn-outline-primary" @click="exportarCSV">
              Descargar reporte CSV
            </button>
            <button class="btn btn-sm btn-success" :disabled="confirmando" @click="confirmar">
              <span v-if="confirmando" class="spinner-border spinner-border-sm me-1"></span>
              Confirmar con diferencias
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ─── Modal: detalle de factura ────────────────────────────────────── -->
  <div v-if="detalleModal" class="modal d-block" style="background:rgba(0,0,0,0.5)">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h6 class="modal-title">{{ detalleModal.serie }}-{{ detalleModal.numero }}</h6>
          <button class="btn-close" @click="detalleModal = null"></button>
        </div>
        <div class="modal-body">
          <table class="table table-sm mb-0">
            <tbody>
              <tr><td class="text-muted small">Proveedor</td><td class="small fw-semibold">{{ detalleModal.proveedor }}</td></tr>
              <tr><td class="text-muted small">Fecha factura</td><td class="small">{{ formatFecha(detalleModal.fecha_emision) }}</td></tr>
              <tr><td class="text-muted small">Fecha importación</td><td class="small">{{ formatFecha(detalleModal.fecha_recep) }}</td></tr>
              <tr><td class="text-muted small">Total (S/)</td><td class="small fw-semibold">{{ fmtMonto(detalleModal.montototdoc) }}</td></tr>
              <tr><td class="text-muted small">Items</td><td class="small">{{ detalleModal.total_items }}</td></tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button class="btn btn-sm btn-outline-secondary" @click="detalleModal = null">Cerrar</button>
          <button class="btn btn-sm btn-primary" @click="seleccionar(detalleModal); detalleModal = null">Recibir</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainHeader from '../../components/Layouts/MainHeader.vue';
import MainSidebar from '../../components/Layouts/MainSidebar.vue';
import BreadcrumbMenu from '../../components/Common/BreadcrumbMenu.vue';
import api from '../../services/api';

export default {
  name: 'RecepcionPage',
  components: { MainHeader, MainSidebar, BreadcrumbMenu },

  data() {
    return {
      compras: [],
      cargandoLista: true,
      compraSeleccionada: null,
      detalleModal: null,
      items: [],
      busqueda: '',
      itemDestacado: null,
      catalogoTallas: [],
      catalogoLineas: [],
      modalDiscrepancias: null,
      confirmando: false,
      cerrando: false,
      errorConfirmar: null,
    };
  },

  computed: {
    productosAgrupados() {
      const q = this.busqueda.trim().toLowerCase();
      const grupos = {};
      for (const item of this.items) {
        if (q && !item.codigo_proveedor?.toLowerCase().includes(q) && !item.producto?.toLowerCase().includes(q)) continue;
        const key = item.codigo_proveedor;
        if (!grupos[key]) {
          const talla = this.catalogoTallas.find(t => t.idtalla === item.idtalla);
          const linea = this.catalogoLineas.find(l => l.idlinea === item.idlinea);
          grupos[key] = {
            codigo_proveedor: key,
            producto: item.producto,
            tallas: [],
            idtalla_sel: undefined,
            idlinea_sel: undefined,
            idtalla_guardado: false,
            nombreTalla: talla?.nombre || '',
            nombreLinea: linea?.nombre || '',
            precvta: parseFloat(item.precvta) || 0,
            precvta_input: parseFloat(item.precvta) > 0 ? parseFloat(item.precvta) : null,
            precvta_guardado: parseFloat(item.precvta) > 0,
          };
        }
        grupos[key].tallas.push(item);
      }
      return Object.values(grupos);
    },
    totalProductos() {
      return new Set(this.items.map(i => i.codigo_proveedor)).size;
    },
    productosCompletos() {
      const grupos = {};
      for (const item of this.items) {
        const k = item.codigo_proveedor;
        if (!grupos[k]) grupos[k] = { total: 0, listos: 0 };
        grupos[k].total++;
        if (item.cantidadRecibida == 0 || item.codbarras || item.barcodeTemporal) grupos[k].listos++;
      }
      return Object.values(grupos).filter(g => g.total === g.listos).length;
    },
    progresoPorc() {
      if (!this.totalProductos) return 0;
      return Math.round((this.productosCompletos / this.totalProductos) * 100);
    },
    itemsConfirmados() {
      return this.items.filter(i => i.stock_actualizado).length;
    },
    itemsPendientes() {
      return this.items.filter(i => !i.stock_actualizado && i.cantidadRecibida > 0 && (i.codbarras || i.barcodeTemporal)).length;
    },
    itemsSinBarcode() {
      return this.items.filter(i => !i.stock_actualizado && i.cantidadRecibida > 0 && !i.codbarras && !i.barcodeTemporal).length;
    },
    gruposSinPrecio() {
      return this.productosAgrupados.filter(g => !g.precvta_guardado).length;
    },
    discrepancias() {
      return this.items
        .filter(i => i.cantidadRecibida != parseInt(i.cantidad) && i.cantidadRecibida != 0)
        .map(i => ({
          ...i,
          cantidadFactura: parseInt(i.cantidad),
          diferencia: i.cantidadRecibida - parseInt(i.cantidad),
        }));
    },
    discrepanciasFaltante() {
      return this.discrepancias.filter(d => d.diferencia < 0).length;
    },
    discrepanciasExceso() {
      return this.discrepancias.filter(d => d.diferencia > 0).length;
    },
  },

  async mounted() {
    this.cargarPendientes();
    try {
      const [tallas, lineas] = await Promise.all([
        api.get('/catalogo/tallas'),
        api.get('/catalogo/lineas'),
      ]);
      this.catalogoTallas = tallas.data.data || [];
      this.catalogoLineas = lineas.data.data || [];
    } catch (e) { console.error('Error catálogos:', e.message); }
  },

  methods: {
    rowItemClass(item) {
      if (item.stock_actualizado) return 'table-light text-muted';
      if (item.cantidadRecibida == 0) return 'table-secondary';
      if (item.cantidadRecibida > 0 && !item.codbarras && !item.barcodeTemporal) return 'table-danger';
      if (item.cantidadRecibida != parseInt(item.cantidad)) return 'table-warning';
      return '';
    },
    grupoCompleto(grupo) {
      return grupo.tallas.every(i => i.cantidadRecibida == 0 || i.codbarras || i.barcodeTemporal);
    },
    grupoParciallisto(grupo) {
      return grupo.tallas.some(i => i.codbarras || i.barcodeTemporal);
    },
    tallasListasGrupo(grupo) {
      return grupo.tallas.filter(i => i.cantidadRecibida == 0 || i.codbarras || i.barcodeTemporal).length;
    },
    totalUnidadesGrupo(grupo) {
      return grupo.tallas.reduce((s, i) => s + parseInt(i.cantidad), 0);
    },
    fmtMonto(v) {
      return Number(v || 0).toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    formatFecha(f) {
      if (!f) return '—';
      const s = String(f).substring(0, 10);
      return new Date(s + 'T00:00:00').toLocaleDateString('es-PE', { day: '2-digit', month: '2-digit', year: 'numeric' });
    },
    verDetalle(c) {
      this.detalleModal = c;
    },
    async cargarPendientes() {
      this.cargandoLista = true;
      try {
        const res = await api.get('/compras/pendientes-recepcion');
        this.compras = res.data.data || [];
      } catch (e) {
        this.compras = [];
      } finally {
        this.cargandoLista = false;
      }
    },
    async seleccionar(compra) {
      this.compraSeleccionada = compra;
      this.busqueda = '';
      const res = await api.get(`/compras/${compra.idreg}/items`);
      this.items = (res.data.data || []).map(i => ({
        ...i,
        barcodeTemporal: i.barcode_recepcion || i.codbarras || '',
        cantidadRecibida: i.cantidad_recibida != null ? Number(i.cantidad_recibida) : Number(i.cantidad),
        stock_actualizado: !!i.stock_actualizado,
        guardandoBarcode: false,
        guardandoCantidad: false,
        _cantidadTimer: null,
      }));
    },
    volver() {
      this.compraSeleccionada = null;
      this.items = [];
      this.busqueda = '';
      this.modalDiscrepancias = null;
      this.errorConfirmar = null;
    },
    async guardarGeneroLinea(grupo) {
      if (grupo.idtalla_sel === undefined || grupo.idlinea_sel === undefined) return;
      try {
        await api.patch(`/compras/${this.compraSeleccionada.idreg}/genero-linea`, {
          codigo_prov: grupo.codigo_proveedor,
          idtalla: grupo.idtalla_sel,
          idlinea: grupo.idlinea_sel,
        });
        grupo.idtalla_guardado = true;
        for (const t of grupo.tallas) {
          t.idtalla = grupo.idtalla_sel;
          t.idlinea = grupo.idlinea_sel;
        }
      } catch (e) { console.error('Error guardando género/línea:', e.message); }
    },
    async guardarPrecioVenta(grupo) {
      if (!grupo.precvta_input || grupo.precvta_input <= 0) return;
      try {
        await api.patch(`/compras/${this.compraSeleccionada.idreg}/precio-venta`, {
          codigo_prov: grupo.codigo_proveedor,
          precvta: grupo.precvta_input,
        });
        grupo.precvta_guardado = true;
        grupo.precvta = grupo.precvta_input;
      } catch (e) { console.error('Error guardando precio de venta:', e.message); }
    },
    async guardarBarcodeItem(item) {
      item.guardandoBarcode = true;
      try {
        await api.patch(`/compras/${this.compraSeleccionada.idreg}/items/${item.iddet}/barcode`, {
          barcode: item.barcodeTemporal || null,
        });
      } finally {
        item.guardandoBarcode = false;
      }
    },
    onCantidadChange(item) {
      clearTimeout(item._cantidadTimer);
      item.guardandoCantidad = true;
      item._cantidadTimer = setTimeout(async () => {
        try {
          await api.patch(`/compras/${this.compraSeleccionada.idreg}/items/${item.iddet}/cantidad-recibida`, {
            cantidad: item.cantidadRecibida,
          });
        } finally {
          item.guardandoCantidad = false;
        }
      }, 800);
    },

    async confirmarParcial() {
      this.confirmando = true;
      this.errorConfirmar = null;
      try {
        const res = await api.post(`/compras/${this.compraSeleccionada.idreg}/recibir`);
        const { items_confirmados, items_pendientes } = res.data.data || {};
        // Marcar en local los ítems que acaban de ser confirmados
        for (const item of this.items) {
          if (!item.stock_actualizado && item.cantidadRecibida > 0 && (item.codbarras || item.barcodeTemporal)) {
            item.stock_actualizado = true;
          }
        }
        if (items_pendientes === 0) {
          await this.cerrarRecepcion();
        }
      } catch (e) {
        this.errorConfirmar = e.response?.data?.error || e.message;
      } finally {
        this.confirmando = false;
      }
    },

    async cerrarRecepcion() {
      this.cerrando = true;
      this.errorConfirmar = null;
      try {
        await api.post(`/compras/${this.compraSeleccionada.idreg}/cerrar-recepcion`);
        if (this.discrepancias.length > 0) this.exportarCSV();
        this.$router.push('/purchase-list');
      } catch (e) {
        this.errorConfirmar = e.response?.data?.error || e.message;
      } finally {
        this.cerrando = false;
      }
    },

    exportarCSV() {
      const compra = this.compraSeleccionada;
      const fecha = new Date().toLocaleDateString('es-PE').replaceAll('/', '-');
      const filas = [
        ['Factura', 'Proveedor', 'Fecha reporte'],
        [`${compra.serie}-${compra.numero}`, compra.proveedor, fecha],
        [],
        ['Código', 'Producto', 'Talla', 'Cant. Factura', 'Cant. Recibida', 'Diferencia', 'Tipo'],
        ...this.discrepancias.map(d => [
          d.codigo_proveedor,
          d.producto,
          d.talla_usa || '—',
          d.cantidadFactura,
          d.cantidadRecibida,
          (d.diferencia > 0 ? '+' : '') + d.diferencia,
          d.diferencia < 0 ? 'Faltante' : 'Exceso',
        ]),
      ];
      const csv = filas.map(r => r.map(c => `"${String(c).replace(/"/g, '""')}"`).join(',')).join('\n');
      const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `diferencias-${compra.serie}-${compra.numero}-${fecha}.csv`;
      a.click();
      URL.revokeObjectURL(url);
    },
  },
};
</script>
